import { render, staticRenderFns } from "./RelatorioLogComunicacao.vue?vue&type=template&id=111a9006&scoped=true&"
import script from "./RelatorioLogComunicacao.vue?vue&type=script&lang=js&"
export * from "./RelatorioLogComunicacao.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioLogComunicacao.vue?vue&type=style&index=0&id=111a9006&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111a9006",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VCard,VDivider,VForm})
